/**
 * Hook: load risk thresholds and violations for a risk (QMS Phase 2)
 */
import { useState, useEffect, useCallback } from 'react';
import { riskThresholdService } from '../services/riskThresholdService';

export function useRiskThresholds(riskId) {
  const [thresholds, setThresholds] = useState([]);
  const [violations, setViolations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    if (!riskId) {
      setThresholds([]);
      setViolations([]);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const [tList, vList] = await Promise.all([
        riskThresholdService.getThresholdsByRiskId(riskId),
        riskThresholdService.getViolationsByRiskId(riskId, 20)
      ]);
      setThresholds(tList);
      setViolations(vList);
    } catch (err) {
      console.error('useRiskThresholds:', err);
      setError(err.message);
      setThresholds([]);
      setViolations([]);
    } finally {
      setLoading(false);
    }
  }, [riskId]);

  useEffect(() => {
    load();
  }, [load]);

  return { thresholds, violations, loading, error, refresh: load };
}
